module.exports = __webpack_public_path__ + "img/PScout64_ua.941ea291.webp";